/* IconButton */
import classNames from "classnames"

import { IconButtonProps } from "@/types/components/button"
import Icon from "@/components/icon/Icon"
import "./iconButton.scss"

export default function IconButton({
  type = "default",
  icon,
  size,
  className,
  disabled,
  hasGroup = false,
  groupDirection,
  additionalIconButton,
  ...props
}: IconButtonProps) {
  const mergedClassName = classNames("IconButtonCont", className, [type, size], {
    disabled,
  })

  if (hasGroup) {
    return (
      <div className={classNames("IconButtonGroupCont", groupDirection)}>
        <button {...props}>
          <Icon type={icon} />
        </button>
        {additionalIconButton}
      </div>
    )
  }

  return (
    <button className={mergedClassName} {...props}>
      <Icon type={icon} />
    </button>
  )
}
